import { useRequestSourceDownload } from '../../api/projects.js';
import { Button, Card } from '../../components/ui.js';
import { useProjectContext } from './ProjectShell.js';

/** Founder-facing, read-only: our developers own the repository, not the founder. */
export function RepositoryPage() {
  const { project } = useProjectContext();
  const repo = project.githubRepoFullName;
  const req = useRequestSourceDownload(project.id);

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <h2 className="mb-2 font-title text-2xl tracking-wide">Repository</h2>
        {repo ? (
          <p className="text-sm leading-relaxed">
            Your project’s code lives in{' '}
            <a
              href={`https://github.com/${repo}`}
              target="_blank"
              rel="noreferrer"
              className="font-medium text-primary underline"
            >
              {repo}
            </a>
            . Our developers commit each built story here, so you can follow progress commit by
            commit.
          </p>
        ) : (
          <p className="opacity-70">
            Our team sets up a private code repository for your project once the specification is
            approved. It will appear here.
          </p>
        )}
      </Card>

      <Card>
        <h2 className="mb-1 font-title text-xl tracking-wide">Source code</h2>
        <p className="mb-3 text-sm opacity-70">
          Would you like a copy of your project’s source code? Ask our team and we’ll be in touch.
        </p>
        <Button
          variant="secondary"
          disabled={req.isPending || req.isSuccess}
          onClick={() => req.mutate()}
        >
          {req.isSuccess
            ? 'Request sent ✓'
            : req.isPending
              ? 'Sending…'
              : 'Request source code download'}
        </Button>
        {req.isSuccess ? (
          <p className="mt-2 text-sm text-primary">
            We’ve received your request and will get back to you.
          </p>
        ) : null}
      </Card>
    </div>
  );
}
